module.exports = __webpack_public_path__ + "img/ic_energy.7fc8a995.svg";